import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Box,
  Paper,
  Grid,
  TextField,
  MenuItem,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { industryinfo } from "../../data/industryinfo";
import LoginDashboard from "../Navbar/MobileSidebar";
import { Country, State, City } from "country-state-city";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import Layout from "../NewDashboard/Layout";
const StudentDetails = () => {
  const [user, setUser] = useState("");
  const [open, setOpen] = useState(false);
  // const [lastname, setLastname] = useState(localStorage.getItem("lastname")?localStorage.getItem("lastname"):"")
  // const [email, setEmail] = useState("")
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [code, setCode] = useState("");
  const [statecode, setCodes] = useState("");
  const [username, setUsername] = useState("");
  const [enrol_id, setEnrol_id] = useState("");
  const [category, setCategorys] = useState("");
  const [backopen, setBackopen] = useState(false);

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    setValue,
    watch,
    trigger
  } = useForm({
    defaultValues: {
      firstname: "",
      lastname: "",
      email: "",
      mobile: "",
      dob: "",
      gender: "",
      address1: "",
      address2: "",
      pincode: "",
      qualification: "",
      university: "",
      industry: "",
      designation: "",
      current_organization: "",
      work_ex: "",
      city: "",
      country: "",
      state: "",
      linkedin: "",
    },
  });

  const LoaderClose = () => {
    setBackopen(false);
  };
  const LoaderOpen = () => {
    setBackopen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const Gender = [
    {
      value: "Male",
      label: "Male",
    },
    {
      value: "Female",
      label: "Female",
    },
    {
      value: "Others",
      label: "Others",
    },
  ];

  let navigate = useNavigate();
  const fetchData = async () => {
    await axios({
      method: "post",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      url: `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/profile/fetchIITKUserDetails`,
      data: {
        user_id: localStorage.getItem("user_id"),
      },
    }).then((res) => {
      if (res.data.status == 200) {
        setData(res.data.data[0]);
        setUsername(res.data.data[0].firstname);

        setValue("firstname", res.data.data[0].firstname || null);
        setValue("lastname", res.data.data[0].lastname || null);
        setValue("email", res.data.data[0].email || null);
        setValue("mobile", res.data.data[0].mobile || null);
        setValue("dob", res.data.data[0].dob || null);
        setValue("gender", res.data.data[0].gender || null);
        setValue("address1", res.data.data[0].address1 || null);
        setValue("address2", res.data.data[0].address2 || null);
        setValue("pincode", res.data.data[0].pincode || null);
        setValue("qualification", res.data.data[0].qualification || null);
        setValue("university", res.data.data[0].university || null);
        setValue("industry", res.data.data[0].industry || null);
        setValue("designation", res.data.data[0].designation || null);
        setValue(
          "current_organization",
          res.data.data[0].current_organization || null
        );
        setValue("work_ex", res.data.data[0].work_ex || null);
        if (
          res.data.data[0].city &&
          res.data.data[0].state &&
          res.data.data[0].country
        ) {
          setValue("country", res.data.data[0].country);
          setValue("city", res.data.data[0].city);
          setValue("state", res.data.data[0].state);
        } else {
          setValue("country", null);
          setValue("city", null);
          setValue("state", null);
        }
        setValue("linkedin", res.data.data[0].linkedin || "");

        console.log(getValues());
        trigger()
      } else {
        console.log("error");
      }

      const arr = Country.getAllCountries();
      const nsate = State.getAllStates();
      for (var i = 0; i < arr.length; i++) {
        if (res.data.data[0].country === arr[i].name) {
          setCode(arr[i].isoCode);
          break;
        }
      }

      for (var j = 0; j < nsate.length; j++) {
        if (res.data.data[0].state === nsate[j].name) {
          //console.log(nsate[j].name);
          setCodes(nsate[j].isoCode);
          break;
        }
      }
    });
  };

  const [data, setData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    mobile: "",
    dob: "",
    gender: "",
    address1: "",
    address2: "",
    pincode: "",
    qualification: "",
    university: "",
    industry: "",
    designation: "",
    current_organization: "",
    work_experience: "",
    technology: "",
    linkedin: "",
  });

  const {
    firstname,
    lastname,
    email,
    mobile,
    dob,
    gender,
    address1,
    pincode,
    qualification,
    university,
    industry,
    designation,
    current_organization,
    work_ex,
    country,
    state,
    city,
  } = data;

  useEffect(() => {
    if (data) {
      console.log(data);
    }
  }, [data]);

  useEffect(() => {
    var user_id = localStorage.getItem("user_id");
    var enrol_id = localStorage.getItem("enrol_id");
    var category = localStorage.getItem("category");
    setUser(user_id);
    setEnrol_id(enrol_id);
    setCategorys(category);
    fetchData();
  }, []);

  useEffect(() => {
    const getCountries = async () => {
      try {
        const result = await Country.getAllCountries();
        let allCountries = [];
        allCountries = result?.map(({ isoCode, name }) => ({
          isoCode,
          name,
        }));

        setCountries(allCountries);
        setSelectedCountry(code);
      } catch (error) {
        setCountries([]);
      }
    };

    getCountries();
  }, [code]);
  const watchedCountry = watch("country");
  const watchedState = watch("state");
  useEffect(() => {
    if (watchedCountry) {
      const getStates = async () => {
        try {
          const result = await State.getStatesOfCountry(watchedCountry);
          const allStates = result.map(({ isoCode, name }) => ({
            isoCode,
            name,
          }));

          setStates(allStates);
          setCities([]);
          setSelectedState("");
          setSelectedCity("");
        } catch (error) {
          setStates([]);
          setCities([]);
          setSelectedCity("");
        }
      };

      getStates();
    }
  }, [watchedCountry]);

  useEffect(() => {
    if (watchedCountry && watchedState) {
      const getCities = async () => {
        try {
          const result = await City.getCitiesOfState(
            watchedCountry,
            watchedState
          );
          const allCities = result.map(({ name }) => ({ name }));

          setCities(allCities);
          setSelectedCity("");
        } catch (error) {
          setCities([]);
        }
      };

      getCities();
    }
  }, [watchedCountry, watchedState]);

  const onSubmit = async (data) => {
    LoaderOpen();
    const {
      firstname,
      lastname,
      email,
      mobile,
      dob,
      gender,
      address1,
      address2,
      pincode,
      qualification,
      university,
      industry,
      designation,
      current_organization,
      work_ex,
      linkedin,
      country,
      state,
      city,
    } = data;
    await axios({
      method: "post",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      url: `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/profile/insertIITKUserDetails`,
      data: {
        user_id: localStorage.getItem("user_id"),
        firstname,
        lastname,
        email,
        mobile,
        dob,
        gender,
        address1,
        address2,
        pincode,
        qualification,
        college_name: university,
        current_industry: industry,
        designation,
        company_name: current_organization,
        experience: work_ex,
        linkedin,
        country,
        state,
        city,
      },
    })
      .then((res) => {
        LoaderClose();
        if (res.data.status == 200) {
          toast.success("Details have been saved successfully!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate("/Dashboard");
        } else {
          Swal.fire({
            title: "Oops!",
            text: "There is an error submitting your details, Please try again later after some time",
            icon: "error",

            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        LoaderClose();
        Swal.fire({
          title: "Oops!",
          text: "There is an error submitting your details, Please try again later after some time",
          icon: "error",

          confirmButtonText: "OK",
        });
      });
  };

  return (
    <>
      {/* <LoginDashboard /> */}
      <Layout>
        <Box
          sx={{
            backgroundColor: "#f3f6f9",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Paper
            sx={{
              borderRadius: "8px",
              boxShadow: "0 0 20px 0 rgb(76 87 125 / 2%)",
              p: 5,
              width: { lg: "90%", xl: "90%", md: "100%", xs: "100%", sm: "100%" },
            }}
          >
            <Typography sx={{ ml: 2, color: "red", fontSize: "18px" }}>
              <i>
                We just need a few more details! Fields marked with * are required
                to access your dashboard.
              </i>{" "}
              <span style={{ fontSize: "0.8rem", color: "#000" }}>
                {/* (<b>Note:</b> All * Fields are mandatory) */}
              </span>
            </Typography>

            <Box sx={{ mb: 4 }}>
              <Paper
                sx={{
                  // ml: 3,
                  // mr:{lg:10,sm:3,md:3,xs:3},
                  borderRadius: "8px",
                  boxShadow: "0 0 20px 0 rgb(76 87 125 / 2%)",
                  p: 2,
                }}
              >
                <Box>
                  <Typography sx={{ fontWeight: "bold", mb: 2 }}>
                    Missing Profile Details
                  </Typography>
                </Box>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Box>
                    <Grid container>
                      {/* Firstname */}

                      {!firstname && (
                        <Grid item lg={6} sm={6} md={6} xs={12} sx={{ mb: 3 }}>
                          <TextField
                            id="First_Name"
                            label="First Name"
                            name="firstname"
                            fullWidth
                            type="text"
                            sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                            {...register("firstname", {
                              required: "First name is required",
                            })}
                            error={!!errors.firstname}
                            helperText={errors.firstname?.message}
                            onKeyPress={(e) => {
                              if (new RegExp(/[a-zA-Z]/).test(e.key)) {
                              } else e.preventDefault();
                            }}
                          />
                        </Grid>
                      )}
                      {/* Lastname */}
                      {!lastname && (
                        <Grid item lg={6} sm={6} md={6} xs={12} sx={{ mb: 3 }}>
                          <TextField
                            id="Last_Name"
                            label="Last Name"
                            name="lastname"
                            fullWidth
                            type="text"
                            sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                            {...register("lastname", {
                              required: "Last name is required",
                            })}
                            error={!!errors.lastname}
                            helperText={errors.lastname?.message}
                            onKeyPress={(e) => {
                              if (new RegExp(/[a-zA-Z]/).test(e.key)) {
                              } else e.preventDefault();
                            }}
                          />
                        </Grid>
                      )}

                      {/* Email */}
                      {!email && (
                        <Grid item lg={6} sm={6} md={6} xs={12} sx={{ mb: 3 }}>
                          <TextField
                            id="E-mail"
                            label="E-mail"
                            name="email"
                            fullWidth
                            type="email"
                            sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                            {...register("email", {
                              required: "Email is required",
                              pattern: {
                                value: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i,
                                message: "Enter a valid email address",
                              },
                            })}
                            error={!!errors.email}
                            helperText={errors.email?.message}
                            disabled
                            InputProps={{
                              sx: {
                                backgroundColor: "#f5f5f5", // optional: make it more visibly gray if needed
                              },
                            }}
                          />
                        </Grid>
                      )}
                      {/* Mobile */}
                      {!mobile && (
                        <Grid item lg={6} sm={6} md={6} xs={12} sx={{ mb: 3 }}>
                          <TextField
                            id="Phone"
                            label="Phone"
                            name="mobile"
                            type="text"
                            fullWidth
                            // required
                            sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                            // sx={{width:{lg:340,sm:340,md:340,xs:"100%"}}}
                            // InputProps={{
                            //   sx: {
                            //     backgroundColor: "#f5f5f5", // optional: make it more visibly gray if needed
                            //   },
                            // }}
                            {...register("mobile", {
                              required: "Mobile number is required",
                              pattern: {
                                value: /^[0-9]+$/,
                                message: "Only numbers are allowed",
                              },
                              maxLength: {
                                value: 12,
                                message: "Mobile number cannot exceed 12 digits",
                              },
                            })}
                            error={!!errors.mobile}
                            helperText={errors.mobile?.message}
                          />
                        </Grid>
                      )}

                      {/* Fathers Name */}
                      {/* {father_name && (
                      <Grid item lg={6} sm={6} md={6} xs={12} sx={{ mb: 3 }}>
                        <TextField
                          id="father_name"
                          label="Father's Name"
                          name="father_name"
                          fullWidth
                          // InputLabelProps={{ shrink: true }}
                          required
                          sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                          {...register("father_name", {
                            required: "Father name is required",
                          })}
                        />
                      </Grid>
                    )} */}

                      {/* Blood Group */}
                      {/* {blood_group && (
                      <Grid item lg={6} sm={6} md={6} xs={12} sx={{ mb: 3 }}>
                        <TextField
                          id="blood_group"
                          label="Blood Group"
                          name="blood_group"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          required
                          sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                          {...register("blood_group", {
                            required: "Blood group is required",
                          })}
                        />
                      </Grid>
                    )} */}

                      {/* DOB */}
                      {!dob && (
                        <Grid item lg={6} sm={6} md={6} xs={12} sx={{ mb: 3 }}>
                          <TextField
                            id="Birth date"
                            label="Date of Birth"
                            name="dob"
                            type="date"
                            fullWidth
                            // required
                            sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                            InputLabelProps={{ shrink: true }}
                            {...register("dob", {
                              required: "Date of birth is required",
                            })}
                            error={!!errors.dob}
                            helperText={errors.dob?.message}
                          />
                        </Grid>
                      )}

                      {/* Gender */}
                      {!gender && (
                        <Grid item lg={6} sm={6} md={6} xs={12} sx={{ mb: 3 }}>
                          <TextField
                            id="gender"
                            select
                            label="Gender"
                            {...register("gender", {
                              required: "Gender is required",
                            })}
                            name="gender"
                            fullWidth
                            // required
                            error={!!errors.gender}
                            helperText={errors.gender?.message}
                            sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                          // InputLabelProps={{ shrink: true }}
                          >
                            {Gender.map((option) => (
                              <MenuItem
                                key={option.value}
                                value={option.value}
                              // selected={option.value == gender}
                              >
                                {option.label}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      )}

                      {/* Address Line 1 */}
                      {!address1 && (
                        <>
                          <Grid
                            item
                            lg={12}
                            sm={12}
                            md={12}
                            xs={12}
                            sx={{ mb: 3 }}
                          >
                            <TextField
                              id="Addressone"
                              label="Address Line 1"
                              name="address1"
                              fullWidth
                              // required
                              sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                              {...register("address1", {
                                required: "Address is required",
                              })}
                              error={!!errors.address1}
                              helperText={errors.address1?.message}
                              onKeyPress={(e) => {
                                if (new RegExp(/^[^<>]*$/).test(e.key)) {
                                } else e.preventDefault();
                              }}
                            />
                          </Grid>

                          {/* Address Line 2 */}
                          <Grid
                            item
                            lg={12}
                            sm={12}
                            md={12}
                            xs={12}
                            sx={{ mb: 3 }}
                          >
                            <TextField
                              id="Addresstwo"
                              label="Address Line 2"
                              name="address2"
                              fullWidth
                              sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                              {...register("address2")}
                              onKeyPress={(e) => {
                                if (new RegExp(/^[^<>]*$/).test(e.key)) {
                                } else e.preventDefault();
                              }}
                            />
                          </Grid>
                        </>
                      )}

                      {!(country && state && city && pincode) && (
                        <>
                          {/* Country */}
                          <Grid item lg={6} sm={6} md={6} xs={12} sx={{ mb: 3 }}>
                            <TextField
                              select
                              id="Country"
                              label="Current Country"
                              name="country"
                              fullWidth
                              // required
                              error={!!errors.country}
                              helperText={errors.country?.message}
                              sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                              onChange={(event) => {
                                console.log(event);
                                setSelectedCountry(event.target.value);
                              }}
                              {...register("country", {
                                required: "Country is required",
                              })}
                            >
                              {countries.map(({ isoCode, name }) => (
                                <MenuItem
                                  value={isoCode}
                                  key={isoCode}
                                // onClick={() => {
                                //   setContryname(name);
                                // }}
                                >
                                  {name}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                          {/* State */}
                          <Grid item lg={6} sm={6} md={6} xs={12} sx={{ mb: 3 }}>
                            <TextField
                              select
                              id="State"
                              label="Current State"
                              name="state"
                              fullWidth
                              // required
                              sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                              onChange={(event) =>
                                setSelectedState(event.target.value)
                              }
                              {...register("state", {
                                required: "State is required",
                              })}
                              error={!!errors.state}
                              helperText={errors.state?.message}
                            >
                              {states.length > 0 ? (
                                states.map(({ isoCode, name }) => (
                                  <MenuItem
                                    value={isoCode}
                                    key={isoCode}
                                  // onClick={() => {
                                  //   setStatename(name);
                                  // }}
                                  >
                                    {name}
                                  </MenuItem>
                                ))
                              ) : (
                                <MenuItem value="" key="">
                                  No state found
                                </MenuItem>
                              )}
                            </TextField>
                          </Grid>

                          {/* City */}
                          <Grid item lg={6} sm={6} md={6} xs={12} sx={{ mb: 3 }}>
                            <TextField
                              select
                              id="City"
                              label="Current City"
                              name="city"
                              fullWidth
                              // required
                              sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                              onChange={(event) =>
                                setSelectedCity(event.target.value)
                              }
                              {...register("city", {
                                required: "City is required",
                              })}
                              error={!!errors.city}
                              helperText={errors.city?.message}
                            >
                              {cities.length > 0 ? (
                                cities.map(({ name }) => (
                                  <MenuItem
                                    value={name}
                                    key={name}
                                  // onClick={() => {
                                  //   setCity(name);
                                  // }}
                                  >
                                    {name}
                                  </MenuItem>
                                ))
                              ) : (
                                <MenuItem value="">No cities found</MenuItem>
                              )}
                            </TextField>
                          </Grid>

                          {/* Pincode */}
                          <Grid item lg={6} sm={6} md={6} xs={12} sx={{ mb: 3 }}>
                            <TextField
                              id="Pincode"
                              label="Pincode"
                              name="pincode"
                              fullWidth
                              // required
                              InputLabelProps={{ shrink: true }}
                              sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                              {...register("pincode", {
                                required: "Pincode is required",
                              })}
                              error={!!errors.pincode}
                              helperText={errors.pincode?.message}
                            />
                          </Grid>
                        </>
                      )}

                      {!(qualification && university) && (
                        <>
                          {/* Qualification */}
                          <Grid item lg={6} sm={6} md={6} xs={12} sx={{ mb: 3 }}>
                            <TextField
                              id="Hac"
                              label="Highest Academic Qualification*"
                              fullWidth
                              sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                              {...register("qualification", {
                                required: "Qualification is required",
                              })}
                              name="qualification"
                              type="text"
                              // required
                              // InputLabelProps={{ shrink: false }}
                              error={!!errors.qualification}
                              helperText={errors.qualification?.message}
                              onKeyPress={(e) => {
                                if (new RegExp(/^[^<>]*$/).test(e.key)) {
                                } else e.preventDefault();
                              }}
                            />
                          </Grid>
                          {/* University */}
                          <Grid item lg={6} sm={6} md={6} xs={12} sx={{ mb: 3 }}>
                            <TextField
                              id="Hqi"
                              label="University/College Name*"
                              fullWidth
                              sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                              {...register("university", {
                                required: "University is required",
                              })}
                              name="university"
                              type="text"
                              // required
                              error={!!errors.university}
                              helperText={errors.university?.message}
                              // InputLabelProps={{ shrink: true }}
                              onKeyPress={(e) => {
                                if (new RegExp(/^[^<>]*$/).test(e.key)) {
                                } else e.preventDefault();
                              }}
                            />
                          </Grid>
                        </>
                      )}

                      {!(
                        industry &&
                        designation &&
                        current_organization &&
                        work_ex
                      ) && (
                          <>
                            {/* Current Industry */}
                            <Grid
                              item
                              lg={6}
                              sm={6}
                              md={6}
                              xs={12}
                              sx={{ mb: 3 }}
                            >
                              <TextField
                                id="Ci"
                                select
                                label="Current industry"
                                {...register("industry", {
                                  required: "Industry is required",
                                })}
                                fullWidth
                                name="industry"
                                sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                                // required
                                error={!!errors.industry}
                                helperText={errors.industry?.message}
                              // InputLabelProps={{ shrink: true }}
                              >
                                {industryinfo.map((option) => (
                                  <MenuItem
                                    key={option.name}
                                    value={option.name}
                                  // selected={option.name == industry}
                                  >
                                    {option.name}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>

                            {/* Current Designation */}
                            <Grid
                              item
                              lg={6}
                              sm={6}
                              md={6}
                              xs={12}
                              sx={{ mb: 3 }}
                            >
                              <TextField
                                id="Cd"
                                label="Current Designation"
                                fullWidth
                                sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                                {...register("designation", {
                                  required: "Designation is required",
                                })}
                                name="designation"
                                type="text"
                                // required
                                error={!!errors.designation}
                                helperText={errors.designation?.message}
                                InputLabelProps={{ shrink: true }}
                                onKeyPress={(e) => {
                                  if (new RegExp(/^[^<>]*$/).test(e.key)) {
                                  } else e.preventDefault();
                                }}
                              />
                            </Grid>

                            {/* Current Org */}
                            <Grid
                              item
                              lg={6}
                              sm={6}
                              md={6}
                              xs={12}
                              sx={{ mb: 3 }}
                            >
                              <TextField
                                id="Co"
                                label="Current Organization"
                                placeholder=""
                                fullWidth
                                sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                                {...register("current_organization", {
                                  required: "Current Organization is required",
                                })}
                                name="current_organization"
                                type="text"
                                // required
                                error={!!errors.current_organization}
                                helperText={errors.current_organization?.message}
                                InputLabelProps={{ shrink: true }}
                                onKeyPress={(e) => {
                                  if (new RegExp(/^[^<>]*$/).test(e.key)) {
                                  } else e.preventDefault();
                                }}
                              />
                            </Grid>

                            {/* Work Exp */}
                            <Grid
                              item
                              lg={6}
                              sm={6}
                              md={6}
                              xs={12}
                              sx={{ mb: 3 }}
                            >
                              <TextField
                                id="Twe"
                                label="Total Work Experience (in years)"
                                fullWidth
                                sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                                {...register("work_ex", {
                                  required: "Work Experience is required",
                                })}
                                InputLabelProps={{ shrink: true }}
                                name="work_ex"
                                type="number"
                                // required
                                error={!!errors.work_ex}
                                helperText={errors.work_ex?.message}
                              />
                            </Grid>
                          </>
                        )}
                      {/* <Grid item lg={12} sm={12} md={12} xs={12} sx={{ mb: 3 }}>
                <TextField
                  id="Et"
                  label="Enter Technology area you work in"
                  fullWidth
                  sx={{ pr:{lg:3,sm:3,md:3,xs:0} }}
                  value={technology}
                  name="technology"
                  type="text"
                  required
                  onKeyPress={(e) => {
                    if (new RegExp(/^[^<>]*$/).test(e.key)) {
                    } else e.preventDefault();
                  }}
                />
              </Grid> */}

                      {/* Linkedin Url */}
                      {/* {linkedin && ( */}
                      <Grid item lg={12} sm={12} md={12} xs={12} sx={{ mb: 3 }}>
                        <TextField
                          id="LinkedIn"
                          label="LinkedIn"
                          placeholder="URL (https://www.linkedin.com/in/username)"
                          fullWidth
                          sx={{ pr: { lg: 3, sm: 3, md: 3, xs: 0 } }}
                          {...register("linkedin", {
                            validate: (value) => {
                              if (!value) return true; // optional field — skip validation if empty
                              return (
                                /^https:\/\/(www\.)?linkedin\.com\/in\/[A-Za-z0-9_-]+\/?$/.test(
                                  value
                                ) || "Enter a valid LinkedIn profile URL"
                              );
                            },
                          })}
                          name="linkedin"
                          InputLabelProps={{ shrink: true }}
                          type="text"
                          error={!!errors.linkedin}
                          helperText={errors.linkedin?.message}
                          onKeyPress={(e) => {
                            if (new RegExp(/^[^<>]*$/).test(e.key)) {
                            } else e.preventDefault();
                          }}
                        />
                      </Grid>
                      {/* )} */}
                      {/*<Grid item lg={6} sm={6} md={6} xs={6} sx={{ mb: 3 }}>
              <Typography sx={{ fontSize: "0.8rem" }}>
                <b>Note:</b> All * Fields are mandatory
              </Typography>
            </Grid>*/}
                      <Grid item lg={12} sm={12} md={12} xs={12} sx={{ mb: 3 }}>
                        <Button
                          variant="contained"
                          type="submit"
                          sx={{
                            mb: 0.3,
                            float: { lg: "right", sm: "right", md: "right" },
                            mr: 3,
                            background: "#009ef7",

                            borderRadius: "8px",
                            textTransform: "none",

                            "&:hover": {
                              background: "#009ef7",

                              borderRadius: "8px",
                              textTransform: "none",
                            },
                          }}
                        >
                          Save changes
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </form>
              </Paper>
            </Box>
          </Paper>
        </Box>
      </Layout>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backopen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />
    </>
  );
};
export default StudentDetails;
